import _noop from 'lodash/noop';
import { ReportErrorToBugsnag, ReportInfoToBugsnag } from './types';

let _reportErrorToBugsnag: ReportErrorToBugsnag = (_e: Error, _o?: any) => {
  _noop();
};
let _reportInfoToBugsnag: ReportInfoToBugsnag = (_i: string, _o?: any) => {
  _noop();
};

export const setBugsnagReporters = (
  reportErrorToBugsnag?: ReportErrorToBugsnag,
  reportInfoToBugsnag?: ReportInfoToBugsnag,
) => {
  _reportErrorToBugsnag = reportErrorToBugsnag || _reportErrorToBugsnag;
  _reportInfoToBugsnag = reportInfoToBugsnag || _reportInfoToBugsnag;
};

export const resetBugsnagReporters = () => {
  _reportErrorToBugsnag = (_e: Error, _o?: any) => {
    _noop();
  };
  _reportInfoToBugsnag = (_i: string, _o?: any) => {
    _noop();
  };
};

export const reportErrorToBugsnagDirect: ReportErrorToBugsnag = (
  e,
  options = {},
) => {
  _reportErrorToBugsnag(e, options);
};

export const reportInfoToBugsnagDirect: ReportInfoToBugsnag = (
  info,
  options = {},
) => {
  _reportInfoToBugsnag(info, options);
};
